module.exports = __webpack_public_path__ + "static/img/backgroundHTN.ead2225e.jpg";